import React from 'react';
import { navigate, useLocation } from '@reach/router';
import cx from 'classnames';
import { AMOUNT_CALCULATOR_PATH } from 'constants/calculators';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { Button, Container, NumberInput, useForm } from 'library';

import './AmountCalculatorHero.scss';

const AmountCalculatorHero = ({
  heading = 'Home Equity Calculator',
  subheading = 'See how much of your home equity you can access from your home.',
  formHeading = 'Enter your estimated home value:',
  backgroundImage,
  onSubmit,
  omitMobileImage,
  estimatedHomeValue,
  isFetchingData,
}) => {
  const { registerField, handleSubmit, formData } = useForm({
    estimatedHomeValue: estimatedHomeValue || '',
  });

  const {
    file: {
      childImageSharp: { fluid },
    },
  } = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "amount-calculator-hero-bg-default.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  if (!backgroundImage) {
    backgroundImage = fluid;
  }

  return (
    <div className={cx('AmountCalculatorHeroContainer', { updateMobileSiblingPadding: omitMobileImage })}>
      <Container
        align="flex-start"
        justify="center"
        className={cx('AmountCalculatorHeroContent', { updateMobileHeight: !omitMobileImage })}
      >
        <h1 className="AmountCalculatorHeroContentHeading">{heading}</h1>
        <p className="AmountCalculatorHeroContentSubheading">{subheading}</p>
        <form className="AmountCalculatorHeroForm" onSubmit={handleSubmit(onSubmit)}>
          <h4 className="AmountCalculatorHeroFormHeading">{formHeading}</h4>
          <div className="AmountCalculatorHeroFormInputs">
            <NumberInput
              {...registerField('estimatedHomeValue')}
              type="currency"
              placeholder="$"
              precision={0}
              required={true}
            />
            <Button type="submit" loading={isFetchingData}>
              Submit
            </Button>
          </div>
        </form>
      </Container>
      <figure className={cx('AmountCalculatorHeroBgImage', { isHiddenOnMobile: omitMobileImage })}>
        {typeof backgroundImage === 'string' ? (
          <img src={backgroundImage} alt="man relaxing on a couch" />
        ) : (
          <Img fluid={backgroundImage} alt="man relaxing on a couch" />
        )}
      </figure>
    </div>
  );
};

export default AmountCalculatorHero;
